import AppCard from "../../../commons/cards/AppCard";
import { Badge } from "react-bootstrap";
import CircularImage from "../../../commons/CircularImage";
import noImg from "../../../assets/images/no-img.jpg";
import { normalizeString } from "../../../commons/util/HallAppUtil";

function hasRule(employee, rule, status) {
  return employee?.rules?.some(r => r.rule === rule && r.status === status);
}

function renderRole(employee, rule, activeLabel, inactiveLabel, activeColor, inactiveColor = "secondary") {
  const isActive = hasRule(employee, rule, "ACTIVE");
  const isInactive = hasRule(employee, rule, "INACTIVE");
  if (!isActive && !isInactive) return null;

  return (
    <Badge bg={isActive ? activeColor : inactiveColor} className="employee-card__badge">
      {isActive ? activeLabel : inactiveLabel}
    </Badge>
  );
}

function EmployeeCard({ employee }) {
  const name = normalizeString(employee?.name || "") || "---";
  const email = employee?.email || "";

  return (
    <div className="employee-card">
      <AppCard accent="brand">
        <div className="employee-card__content" role="group" aria-label={`Colaborador ${name}`}>
          <CircularImage
            url={employee?.photo || noImg}
            width="104px"
            height="104px"
            alt={`Foto de ${name}`}
          />

          <div className="employee-card__info">
            <p className="employee-card__name">{name}</p>
            {email && <p className="employee-card__email">{email}</p>}

            <div className="employee-card__badges" aria-label="Papéis do colaborador">
              {renderRole(employee, "COMPANY", "Administrador", "Administrador", "success")}
              {renderRole(employee, "EMPLOYEE", "Funcionário", "Funcionário", "primary")}
              {renderRole(employee, "RECEPTION", "Recepção", "Recepção", "primary")}
            </div>
          </div>
        </div>
      </AppCard>
    </div>
  );
}

export default EmployeeCard;